import { useContext, useEffect, useState } from "react";
import { Container, Flex, Heading, MTabs, Text } from "@cisco/spaces-dash-lib-styleguide";
import { I18nContext } from "../../contexts/i18nContext";
import "./partner-with-us.css";

// Extend Window interface to include hbspt
declare global {
  interface Window {
    hbspt?: {
      forms: {
        create: (config: { portalId: string; formId: string; target: string }) => void;
      };
    };
  }
}

function PartnerWithUs(): JSX.Element {
  const i18n = useContext(I18nContext);

  if (!i18n) {
    throw new Error("PartnerWithUs must be used within an I18nContext.Provider");
  }

  const { t } = i18n;
  const [selectedTab, setSelectedTab] = useState<"app" | "device" | "customer">("app");

  useEffect(() => {
    if (window.hbspt) {
      window.hbspt.forms.create({
        portalId: "5010372",
        formId: "3d2958bc-9d47-4736-bb2b-cb8abcb7219e",
        target: "#hubspotForm1"
      });

      window.hbspt.forms.create({
        portalId: "5010372",
        formId: "7b07f2f3-fdab-4e5e-aa12-5583098924ff",
        target: "#hubspotForm2"
      });
    }
  }, [selectedTab]);

  return (
    <Flex direction="vertical" align="center" gap={12} style={{ marginBottom: "2.5rem" }} id="partner_withus">
      <Heading size="primary" style={{ marginTop: "2.5rem" }}>
        {t("auth.login.login-partner-base.contact-cisco-spaces-team-text", { ns: "spaces-dash-app-partners-login" })}
      </Heading>
      <Text>{t("auth.login.login-partner-base.get-in-touch-shortly", { ns: "spaces-dash-app-partners-login" })}</Text>
      <Flex align="center" gap={16} justify="center" style={{ width: "100%" }}>
        <Text>{t("auth.login.login-partner-base.i-am-a-text", { ns: "spaces-dash-app-partners-login" })}: </Text>
        <MTabs style={{ width: "50%" }} kind="secondary">
          <MTabs.Link
            selected={selectedTab === "app"}
            onClick={() => {
              setSelectedTab("app");
            }}
          >
            {t("auth.login.login-partner-base.application-or-solution-partner-text", { ns: "spaces-dash-app-partners-login" })}
          </MTabs.Link>
          <MTabs.Link
            selected={selectedTab === "device"}
            onClick={() => {
              setSelectedTab("device");
            }}
          >
            {t("auth.login.login-partner-base.device-vendor-partner", { ns: "spaces-dash-app-partners-login" })}
          </MTabs.Link>
          <MTabs.Link
            selected={selectedTab === "customer"}
            onClick={() => {
              setSelectedTab("customer");
            }}
          >
            {t("auth.login.login-partner-base.existing-cisco-spaces-customer", { ns: "spaces-dash-app-partners-login" })}
          </MTabs.Link>
        </MTabs>
      </Flex>
      <Container className="hubspot-container">
        {selectedTab === "app" && <Flex id="hubspotForm1" />}
        {selectedTab === "device" && <Flex id="hubspotForm2" />}
        {selectedTab === "customer" && (
          <Flex align="center">
            <Text style={{ textAlign: "center" }}>{t("auth.login.login-partner-base.own-partner-portal-text", { ns: "spaces-dash-app-partners-login" })}</Text>
          </Flex>
        )}
      </Container>
      <Text size="p4" weight="light">
        {t("auth.login.login-partner-base.information-you-provide-to-cisco", { ns: "spaces-dash-app-partners-login" })}{" "}
        <a style={{ color: "#1d69cc", textDecoration: "none" }} href="https://www.cisco.com/c/en_in/about/legal/privacy-full.html" target="_blank" rel="noreferrer">
          {t("auth.login.login-partner-base.privacy-policy-small-text", { ns: "spaces-dash-app-partners-login" })}
        </a>
      </Text>
    </Flex>
  );
}

export default PartnerWithUs;
